import { fabric } from 'fabric';
import delay from 'delay';

const BORDER_COLOR = '#bbb';
const BORDER_WIDTH = 1;
const PATTERN_URL = '/assets/static/storage_map/pattern.png';

export default fabric.util.createClass(fabric.Object, {
  type: 'StoreWalls',
  initialize(map, options) {
    this.map = map;
    this.xOffset = options.xOffset;
    this.yOffset = options.yOffset;
    this.callSuper('initialize', { ...options, evented: false });

    this.fabricNode = this._buildNode();
    this._loadPattern(PATTERN_URL);
  },
  _render(ctx) {
    this.fabricNode.render(ctx);
  },
  _buildNode() {
    const left = -this.width / 2.0;
    const top = -this.height / 2.0;

    const clipPath = new fabric.Rect({
      left: left + this.xOffset,
      top: top + this.yOffset,
      width: this.width - this.xOffset * 2,
      height: this.height - this.yOffset * 2,
      inverted: true
    });

    return new fabric.Rect({
      left,
      top,
      width: this.width,
      height: this.height,
      clipPath
    });
  },
  _loadPattern(url) {
    fabric.util.loadImage(url, async img => {
      this.fabricNode.set('fill', new fabric.Pattern({
        source: img,
        repeat: 'repeat'
      }));
      this.dirty = true;
      this.canvas.requestRenderAll();
    });
  }
});
